import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Login } from '../models/login.model';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginRequest } from '../models/Requests/LoginRequest.model';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  apiUrl: string = "Authentication/Login";
  roleBasedApiUrl: string = "RoleBasedAccess/Level"
  authorizeUrl: string = "Authentication/Access"
  isAuthUser = new BehaviorSubject<boolean>(false);
  setLogin = new BehaviorSubject<Login>(new Login("", "", "", "", "", "", 0, false,false,false,""));

  constructor(private http: HttpClient) { }

  authenticate(login: Login): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    return this.http.post(environment.baseUrl + this.apiUrl, login, { headers: headers })
  }

  authorize(login: Login): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    return this.http.post(environment.baseUrl + this.authorizeUrl, login, { headers: headers })
  }

  getUserAccessLevel(loginRequest: LoginRequest): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(loginRequest);
    return this.http.post<any>(environment.baseUrl + this.roleBasedApiUrl, body, { headers: headers }).pipe(map(data => {
      return data.body;
    }));
  }
}
